import Cookies from 'js-cookie';

const authFetch = async (url, options = {}) => {
  const token = Cookies.get('authToken');
  const response = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
  });

  if (response.status === 401) {
    Cookies.remove('authToken');
    localStorage.removeItem('fintechId');
    localStorage.removeItem('adminId');
    window.location.href = '/';
  }

  return response;
};

export default authFetch;
